import { AuthSession, AuthUser } from 'aws-amplify/auth';
import { StateConstants } from 'src/constants';

// Points to the first name of the user
const CLAIM_GIVEN_NAME = 'given_name';

const getUserAlias = (authUser: AuthUser | undefined): string => {
  return parseFederateUsername(authUser?.username ?? StateConstants.EMPTY_STRING);
};

const getGivenName = (authSession: AuthSession | undefined): string => {
  return (
    authSession?.tokens?.idToken?.payload[CLAIM_GIVEN_NAME]?.toString() ??
    StateConstants.EMPTY_STRING
  );
};

const parseFederateUsername = (username: string): string => {
  // Example: AmazonFederate_user
  return username.split('_')[1] ?? StateConstants.EMPTY_STRING;
};

export { getUserAlias, getGivenName, parseFederateUsername };
